// Public React routes where an unauthenticated session is expected.
// The Apollo error link and the ActionCable reject-storm guard both consult
// this list so they don't kick users off pages where being logged-out is
// the whole point (reset-password, invitation acceptance, etc.).
//
// Keep in sync with app/javascript/routes.js — any guard-less / GuestGuard'd
// route that expects to render without an authenticated user belongs here.
export const PUBLIC_PATH_PREFIXES = [
  "/login",
  "/choose-workspace",
  "/reset-password",
  "/invitation",
  "/forgot-password",
  "/auth",
  "/403",
  "/404",
  "/shared-planner",
];

export const isPublicPath = pathname =>
  PUBLIC_PATH_PREFIXES.some(prefix => pathname === prefix || pathname.startsWith(prefix + "/"));
